export default {
    slogan: "隨時隨地，愛上交易",
    download_item_name: "Pionex派網 App",
    download_item_desc: "前往TestFlight下載最新版本",
    download_item_question: "安裝有問題?",
    download_item_click_tip: "點此獲取解決方法",
    download_drawer_title: "常見問題",
    download_drawer_tip1: "我的TestFlight無法接入App Store connect?",
    download_drawer_tip2: "需要填寫兌換碼?",
    download_drawer_invite_code_issue: "點擊取消，關閉兌換碼後再次點擊下載，反復嘗試後如果還是需要填寫驗證碼，可以嘗試切換網絡",
    download_drawer_connect_issue: "可切換至海外網絡後再訪問TestFlight下載，或者使用海外Apple ID（蘋果賬號）直接在App Store搜尋「Pionex」下載。",
    download_drawer_button_acquire_id: "獲取海外ID和教程",
    download_drawer_button_human_service: "沒有解決？聯絡人工客服",
    download_drawer_button_human_service_title: "人工客服",
    download_drawer_button_human_service_desc: "微信掃碼添加人工客服",
    download_tutor_click_hint: "點擊右上角的",
    download_tutor_open_safari_hint: "選擇「在Safari中打開」",
    download_tutor_open_browser_hint: "選擇「在瀏覽器中打開」",
    download_tutor_pionex_desc1: "全自動低買高賣",
    download_tutor_pionex_desc2: "網格交易 選派網",
    download_android_item_desc: "點擊下載apk文件",
    download_tutor_bottom_slogan: "派網·全球首家量化交易所",

    homepage_downloadapp_ios: "iOS",
    homepage_downloadapp_android: "Android",
    homepage_downloadapp_title_1: "隨時隨地",
    homepage_downloadapp_title_2: "愛上交易",
    download_button_text: "下載",
    down_load_gp_version: "Google Play版本",
    down_load_gp_version_desc: "從Google Play下載",
    down_load_apk_version: "APK版本",
    down_load_apk_version_desc: "直接下載apk文件來安裝",
    down_load_app_store_version: "AppStore版本",
    down_load_app_store_version_desc: "直接從AppStore上下載",
    down_load_testflight_version: "TestFlight版本",
    down_load_testflight_version_desc: "從TestFlight上下載，體驗最新功能",
    slogan_2fa: "谷歌身份驗證器",
    down_load_app_store_version_desc_2fa: "從AppStore下載",
    download_item_desc_2fa: "從 AppStore 中下載最新版本",

};
